(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    flex-direction: column;\n    height: initial;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex } from "../layout";
import { media } from "../../helpers/responsive";
import Step from "./Step.js";
var StyledFlex = styled(Flex).withConfig({
  displayName: "StepProgress__StyledFlex",
  componentId: "sc-ssqqbw-0"
})(["border:2px solid #eee;height:64px;padding:8px;border-radius:4px;", ""], media.css.mobile.and('down')(_templateObject()));

var StepProgress = function StepProgress(props) {
  var steps = props.steps,
      currentStep = props.currentStep,
      onStepClick = props.onStepClick,
      rest = _objectWithoutProperties(props, ["steps", "currentStep", "onStepClick"]);

  var currentIndex = steps.findIndex(function (step) {
    return step.id === currentStep;
  });
  return React.createElement(StyledFlex, rest, steps.map(function (step, index) {
    return step.hideInProgessTracker === true ? null : React.createElement(Step, {
      index: index,
      key: step.id,
      step: _objectSpread({}, step),
      active: index === currentIndex,
      done: index < currentIndex,
      onClick: step.onClick,
      title: step.title
    });
  }));
};

StepProgress.defaultProps = {
  steps: []
};
StepProgress.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    active: PropTypes.bool,
    done: PropTypes.bool,
    title: PropTypes.string,
    onClick: PropTypes.func
  }))
};
var _default = StepProgress;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StyledFlex, "StyledFlex", "/home/vsts/work/1/s/src/components/steps/StepProgress.js");
  reactHotLoader.register(StepProgress, "StepProgress", "/home/vsts/work/1/s/src/components/steps/StepProgress.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/steps/StepProgress.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();